import { startSubmit, stopSubmit } from 'redux-form';

// FIXME: Sort out the naming collisions
import { deleteTicketAttachment as deleteTicketAttachmentApi, uploadTicketAttachments } from './rest';
import { updateCachedTicketAttachments } from './graphql';
import { isAxiosResponseError } from '../../../utils/errorTypeCheck';

import { TicketViewerQuery } from '../components/TicketSubmissionItemViewer';

/*
* Uploads ticket attachments and refreshes the apollo cache for the given ticket
* NOTE: with token refreshing, both axios and apollo will return new tokens. Last call
* should be in localstorage.
 */
export const submitTicketAttachmentUpload = (formValues, ticketId) => {
  return async (dispatch, getState, { client, axios }) => {
    const { files, ...descriptions } = formValues;
    const fileMap = files.reduce((acc, val, index) => {
      acc[`file-${index}`] = val;
      return acc;
    }, {});

    try {
      dispatch(startSubmit('ticketAttachmentUpload'));
      await uploadTicketAttachments(axios, ticketId, fileMap, descriptions);
      await updateCachedTicketAttachments(client, ticketId);

      await client.query({
        query: TicketViewerQuery,
        variables: {
          ticketId,
        },
      });


      dispatch(stopSubmit('ticketAttachmentUpload', {}));
    } catch (e) {
      if (!isAxiosResponseError(e)) {
        throw e;
      }
      dispatch(stopSubmit('ticketAttachmentUpload', { _error: 'Failed' }));
      throw e;
    }
  };
};


/*
* Deletes an attachment and refreshes the apollo cache for the given ticket
 */
export const deleteTicketAttachment = (ticketId, attachmentId) => {
  return async (dispatch, getState, { client, axios }) => {
    await deleteTicketAttachmentApi(axios, attachmentId);
    await updateCachedTicketAttachments(client, ticketId);

    await client.query({
      query: TicketViewerQuery,
      variables: {
        ticketId,
      },
    });
  };
};
